// my-project/Metrics.js
import { createMetricsFactory } from 'metrics-js';
export const Metrics = createMetricsFactory('crm-tasks-ui');